"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _downshift = _interopRequireDefault(require("downshift"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactDeviceDetect = require("react-device-detect");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("./styles"));
var _withContext = require("./withContext");
var _useLockBodyScroll = require("./useLockBodyScroll");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Dropdown = function Dropdown(_ref) {
  var className = _ref.className,
    children = _ref.children,
    triggerButton = _ref.triggerButton;
  var dropdownContext = (0, _withContext.useDropdownContext)();
  var isOpen = dropdownContext.isOpen,
    close = dropdownContext.close,
    open = dropdownContext.open;
  var isTriggerButtonRenderFunc = typeof triggerButton === 'function';
  (0, _useLockBodyScroll.useLockBodyScroll)(_reactDeviceDetect.isMobileOnly && isOpen);
  return /*#__PURE__*/_react.default.createElement(_downshift.default, {
    isOpen: isOpen,
    onOuterClick: _reactDeviceDetect.isMobileOnly ? undefined : close
  }, function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_styles.default.dropdown, className)
    }, isTriggerButtonRenderFunc ? triggerButton(dropdownContext) : triggerButton.props.disabled ? triggerButton : (0, _react.cloneElement)(triggerButton, {
      onClick: isOpen ? close : open
    }), isOpen && children);
  });
};
Dropdown.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  triggerButton: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]).isRequired
};
var _default = exports.default = (0, _react.memo)(Dropdown);